module.exports = __webpack_public_path__ + "img/24-2.80f6d174.jpg";